export const SUBMISSIONS_FETCH = 'SUBMISSIONS_FETCH';
export const SUBMISSIONS_SELECT = 'SUBMISSIONS_SELECT';
